'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withEventListeners = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// event names coercion
var withEventListeners = function withEventListeners(WrappedComponent) {
  var WithEventListeners = function (_Component) {
    _inherits(WithEventListeners, _Component);

    function WithEventListeners(props) {
      _classCallCheck(this, WithEventListeners);

      var _this = _possibleConstructorReturn(this, (WithEventListeners.__proto__ || Object.getPrototypeOf(WithEventListeners)).call(this, props));

      _this.state = {
        eventListeners: {}
      };

      _this._toggleEventListener = _this._toggleEventListener.bind(_this);
      _this._cleanEventListeners = _this._cleanEventListeners.bind(_this);
      return _this;
    }

    _createClass(WithEventListeners, [{
      key: '_toggleEventListener',
      value: function _toggleEventListener(newListener) {
        var _state$eventListeners = this.state.eventListeners,
            existedListener = _state$eventListeners[newListener.event],
            eventListeners = _objectWithoutProperties(_state$eventListeners, [newListener.event]);

        if (existedListener) {
          existedListener.target.removeEventListener(existedListener.event, existedListener.cb);
          this.setState({ eventListeners: eventListeners });
        } else {
          var _target = newListener.target,
              event = newListener.event,
              cb = newListener.cb;

          _target.addEventListener(event, cb);
          this.setState(function (_ref) {
            var eventListeners = _ref.eventListeners;
            return {
              eventListeners: _extends({}, eventListeners, _defineProperty({}, event, newListener))
            };
          });
        }
      }
    }, {
      key: '_cleanEventListeners',
      value: function _cleanEventListeners() {
        var _this2 = this;

        var listeners = this.state.eventListeners;
        Object.values(listeners).forEach(function (listener) {
          _this2._toggleEventListener(listener);
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
          toggleEventListener: this._toggleEventListener,
          cleanEventListeners: this._cleanEventListeners
        }));
      }
    }]);

    return WithEventListeners;
  }(_react.Component);

  return WithEventListeners;
};
exports.withEventListeners = withEventListeners;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tooltip/dist/common.js
// module id = 234
// module chunks = 0